export default __webpack_public_path__ + "assets/31eb839fb56a9ef0ca12e24d6038bc9d.png";